namespace appn.views.taskTemplates.wizard1 {

    class InitArgs {
        isRecurringContext: boolean = false;
        tasksCreate: string = emptyString;
    }

    let _initArgs: InitArgs;

    export function init(args: InitArgs): void {
        _initArgs = args;
        addEvents();
    }

    function addEvents() {
        $('#blankTask').on('click', function(event) {
            event.preventDefault();
            const returnAction: string = $('#ReturnAction').attr('value') as string;

            if (_initArgs.isRecurringContext)
                (parent as any).appn.location.navTo(_initArgs.tasksCreate, [
                    {
                        name: 'isTaskRecurringContext',
                        value: 'true'
                    },
                    {
                        name: 'returnAction',
                        value: returnAction
                    }
                ]);
            else
                (parent as any).appn.location.navTo(_initArgs.tasksCreate, [
                    { name: 'isTaskRecurringContext', value: 'false' },
                    { name: 'returnAction', value: returnAction }
                ]);
        });

        $('#templateTask').on('click', function(event) {
            const template: string = $('#Wizard_Template_Id').val() as string;

            if (template === undefined || template.length === 0)
                event.preventDefault();
        });
    }
}
